import { render, staticRenderFns } from "./ClassifiedAd.vue?vue&type=template&id=6ab78220&scoped=true&"
import script from "./ClassifiedAd.vue?vue&type=script&lang=js&"
export * from "./ClassifiedAd.vue?vue&type=script&lang=js&"
import style0 from "./ClassifiedAd.vue?vue&type=style&index=0&id=6ab78220&scoped=true&lang=css&"
import style1 from "./ClassifiedAd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab78220",
  null
  
)

export default component.exports